import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box, Typography, Button
} from "@mui/material";
import { styled } from "@mui/system"
import PropTypes from 'prop-types'
import lottie from "lottie-web";
import * as config from "../../../next.config.js"
import LoadingButton from '@mui/lab/LoadingButton'
import FormControl, { } from "@mui/material/FormControl"
import { useTranslation } from 'next-i18next'
import FormHelperTxet from '@mui/material/FormHelperText'
import { useCart } from "../../../context/cart/use-cart";
import { getCookieValue,isOnlyDigits } from "../../helpers/helpers";
import {Customebtn} from "../StyledComponent/HintDialog1.style"
import {CustomeDialogContent} from "../StyledComponent/HintDialog1.style"
import {CustomeDialogActions} from "../StyledComponent/HintDialog1.style"
import {BootstrapDialog} from "../StyledComponent/HintDialog1.style"
import {CustomeTextField2} from "../StyledComponent/HintDialog1.style"
import {CustomeFormControl2} from "../StyledComponent/HintDialog1.style"

export default function QuantityDialog(props) {
  const { t } = useTranslation("common")
  const [Quantity, setQuantity] = useState(props.quantity)
  const { addItem, removeItem, isInCart, getItem,selectQuantityItem} = useCart();
  const handleChange= (event) => {
      if(event.target.value != null && event.target.value != ""){
  setQuantity(parseInt(event.target.value))
  }else{
    setQuantity(null)
  }
}
  const allowOnlyNumerics = (e) => {
    const charcode = e.which ? e.which : e.keyCode;
    if (!(charcode > 31 && (charcode < 48 || charcode > 57))) {
    }
    else {
      e.preventDefault();
    }
  }
  const handleSend = (e) => {
   if( Quantity != null && Quantity != props.quantity  ){
    selectQuantityItem({
        type: "products",
        entityId:props.productId,
        isFavoriate: false,
        quantity: Quantity,
        productUnitPrice: props.productUnitPriceId,
        entityDetailsId: props.entityDetailsId,
        userCountry: getCookieValue("userCountry")
        
      })
    
   }
   props.btnOk()
  }
  useEffect(() => {
  

  }, [props.open])
  return (
    <>
      <BootstrapDialog
        open={props.open}
        maxWidth={"xs"}
        fullWidth
        onClose={props.onClose}
        PaperProps={{
          sx: { overflow: "visible",  position: "relative" },

        }}
      >
   
        <CustomeDialogContent style={{ position: "relative", width: "100%" }}>
          <br />
          {props.title ? <Typography
            style={{ textAlign: "center", fontWeight: "bold",  color: "#F52A59", padding: "10px 0px" }}
            variant="h3"
          >
            {/* {props.title} */}

          </Typography> : ""}
          <Typography
            style={{ textAlign: "center", fontWeight: "bold",  padding: "10px 0px" }}
            variant="h5"
          >
              {"تحديد الكمية"}
            {/* {props.text} */}

          </Typography>      
            <CustomeFormControl2
              style={{ direction: "rtl" }}
            >

              <CustomeTextField2
                value={Quantity}
                onChange={handleChange}
                onKeyPress={(event) => { allowOnlyNumerics(event) }}
                sx={{
                  width: "100%",
                  margin: "0 ",
                  display: "flex !important",
                  borderRadius: 0,
                  textAlign:"center !important",
                  fontSize:"16px !important",

                }}
              />
              {/* <FormHelperTxet
                error={errors.note != null ? true : false}
                style={{ textAlign: "start" }} >
                {errors.note}
              </FormHelperTxet> */}
            </CustomeFormControl2> 
        </CustomeDialogContent>
        <CustomeDialogActions
          justifyContent="center"
          style={{ justifyContent: "center" }}
        >
          <Customebtn
            variant={"contained"}
            // sx={{ backgroundColor: "#F52A59 !important" }}
            onClick={props.btnCancel}
            loading={props.loading}
            color="primary"
          >
            {t("btnCancel")}

          </Customebtn>

          <Customebtn
            variant={"contained"}
            loading={props.loading}
            onClick={(e)=> handleSend(e)}
            color="primary"
          >
             {t("btnOk")} 
          </Customebtn>

        </CustomeDialogActions>
        {props.children}
      </BootstrapDialog>
    </>
  );
}
// QuantityDialog.propTypes = {
//   confirm: PropTypes.func,
//   reject: PropTypes.func,
//   open: PropTypes.bool,
//   onClose: PropTypes.func,
//   text: PropTypes.string
// }